/** @format */
import { RefObject, useEffect } from 'react';

/**
 * This hook is used to listen to blur events within the dom element its attached to
 */
export const useBlurWithin = (
    ref: RefObject<HTMLElement>,
    handler: (event: Event) => void
) => {
    const blurHandler = (event: FocusEvent) => {
        handler(event);
    };

    useEffect(() => {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions, @typescript-eslint/prefer-optional-chain -- Legacy code: do not use as an example.
        ref.current && ref.current.addEventListener('blur', blurHandler, true);

        return () => {
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions, @typescript-eslint/prefer-optional-chain -- Legacy code: do not use as an example.
            ref.current &&
                // eslint-disable-next-line react-hooks/exhaustive-deps -- Legacy code: do not use as an example.
                ref.current.removeEventListener('blur', blurHandler, true);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps -- Legacy code: do not use as an example.
    }, [ref.current, handler]);
};
